<template>
    <aside class="main-sidebar col-md-3">
        <!-- sidebar: style can be found in sidebar.less -->
        <section class="sidebar">
            <!-- Sidebar user panel -->
            <div class="photoBox">
                <a class="changePhotoLink" href="https://www.abft.be">
                    <!--<i class="fa fa-picture-o"></i>-->
                    Retourner <br/>sur le site
                </a>
                <!--<img v-if="getMember.photo!=null" :src="getMember.photo" class="img-responsive" alt=""/>-->
                <img v-if="getMember.photo==null" @click="show_upload_logo=!show_upload_logo" src="../../assets/img/logos/logoAbftBE.jpg" class="img-responsive" alt=""/>

                <!--<my-upload field="img"-->
                <!--@crop-success="cropSuccess"-->
                <!--@crop-upload-success="cropUploadSuccess"-->
                <!--@crop-upload-fail="cropUploadFail"-->
                <!--v-model="show_upload_logo"-->
                <!--langType="fr"-->
                <!--:height="200"-->
                <!--:width="300"-->
                <!--:noCircle="true"-->
                <!--img-format="jpg">-->
                <!--</my-upload>-->

                <div class="nameBox">
                    <p>{{ getMember.fullname }}</p>
                    <p class="sousName">{{ ucwords(getMember.lastClub) }}</p>
                </div>
            </div>

            <div class="col-md-12 tableSection">
                <h3><i class="fa fa-user"></i> Profil</h3>

                <div v-if="getMember.numlicenceABFT" class="col-md-5 cell brRight">
                    <span class="mainTitle">{{ getMember.numlicenceABFT }}</span>
                    <span class="subTitle">N° licence</span>
                </div>
                <div v-if="getMember.age>0" class="col-md-3 cell brRight">
                    <span class="mainTitle">{{ getMember.age }}</span>
                    <span class="subTitle">ans</span>
                </div>
                <div class="col-md-4 cell"  v-if="getMember.ranking!=null" style="padding-left: 5px;padding-right: 5px;">
                <span class="mainTitle" v-if="getMember.ranking!=null">
                   {{ getMember.categorie_poids.replace("kg","") }}<sub>kg</sub>
                </span>
                    <span class="mainTitle" v-if="getMember.ranking==null">
                   -
                </span>
                    <span class="subTitle">Cat. Poids</span>
                </div>
            </div>
            <div class="col-md-12 tableSection">
                <div class="cell">
                    <span class="mainTitle grade" v-html="getMember.gradeMax != null ? getMember.gradeMax : 'Grade non-communiqué'"> <i class="icons icon-up"></i></span>
                    <span class="subTitle" v-if="getMember.gradeMax != null">Grade</span>
                    <span v-if="getMember.gradeMax != null" class="subTitle" style="line-height: 20px;margin-top: 25px;">Prochain passage possible<br/> à l'ABFT: {{getProchainPassage()}}</span>
                </div>
            </div>
            <div class="col-md-12 tableSection" v-if="getMember.lastLicence">
                <div class="cell">
                    <span class="mainTitle clubName">{{ ucwords(getMember.lastLicence.club.club) }}</span>
                    <span class="subTitle" style="margin-top: 5px;">Dernière affiliation: <br> {{  getMember.lastLicence.date_debut}} - {{  getMember.lastLicence.date_fin}}</span>
                </div>
            </div>
            <div class="col-md-12 tableSection" v-if="!getMember.lastLicence">
                <div class="cell">
                    <span class="mainTitle clubName">Aucune licence ABFT active</span>
                </div>
            </div>
            <div class="col-md-12 tableSection" v-if="getMember.ranking">
                <h3 style="margin-bottom: 0; "><i class="fa fa-star"></i>
                    Ranking
                    <small><em>{{ number_format(getMember.ranking.totalBonus, 0, ",", ".") }} pts</em></small>
                    <a target="_blank" :href="getMember.RankingLink">Voir la fiche</a>
                </h3>

                <div class="col-md-12 tableSection medals">

                    <div class="medal"><i class="icons-icon-or"></i><span>{{ getMember.medailles["or"] }}</span></div>
                    <div class="medal"><i class="icons-icon-argent"></i><span>{{ getMember.medailles["arg"] }}</span>
                    </div>
                    <div class="medal"><i class="icons-icon-bronze"></i><span>{{ getMember.medailles["brz"] }}</span>
                    </div>
                    <span class="subTitle">Médailles remportées</span>
                </div>
                <div class="col-md-12 tableSection">
                    <div class="col-md-6 cell brRight">
                <span class="mainTitle">
                    {{ getMember.placeRankingGeneral }}
                        <sup v-html="getMember.placeRankingGeneral==1 ? 'er' : getMember.placeRankingGeneral+'ème'"></sup>
                    </span>
                        <span class="subTitle">Ranking Général</span>
                    </div>
                    <div class="col-md-6 cell">
                <span class="mainTitle">
                    {{ getMember.placeRankingSexe }}
                     <sup v-html="getMember.placeRankingSexe==1 ? 'er' : getMember.placeRankingSexe+'ème'"></sup>
                    </span>
                        <span class="subTitle" v-html="getMember.sexe==1 ? 'Ranking Masculin':'Ranking Féminin'"></span>
                    </div>
                </div>
            </div>
        </section>
    </aside>
</template>

<style scoped>
    .main-sidebar {
        margin-top: 0;
        padding: 0;
        background-color: #292e33;

    }

    .sidebar {
        padding-top: 0;
    }
</style>

<script type="text/babel">
    import Auth from '@/auth'
    import {mapGetters, mapActions} from 'vuex'
    import cropUpload from '../ImgCropUpload'
    import {getProchainPassage} from "../../utils/utils";

    var moment = require('moment')
    export default {
        data() {
            return {
                show_upload_logo: false
            }
        },
        components: {
            'my-upload': cropUpload
        },
        methods: {
            getProchainPassage() {
                return getProchainPassage(this.getMember.prochainPassage)
            },
            cropSuccess(imgDataUrl, field) {
                this.getMember.photo = imgDataUrl;
            },
            cropUploadSuccess(jsonData, field) {
            },
            cropUploadFail(status, field) {
            },
            ucwords: function (str) {
                if (!str)
                    return ""
                return str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
            },

            number_format: function (number, decimals, dec_point, thousands_point) {

                if (number == null || !isFinite(number)) {
                    throw new TypeError("number is not valid");
                }

                if (!decimals) {
                    var len = number.toString().split('.').length;
                    decimals = len > 1 ? len : 0;
                }

                if (!dec_point) {
                    dec_point = '.';
                }

                if (!thousands_point) {
                    thousands_point = ',';
                }

                number = parseFloat(number).toFixed(decimals);

                number = number.replace(".", dec_point);

                var splitNum = number.split(dec_point);
                splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands_point);
                number = splitNum.join(dec_point);

                return number;
            }
        },
        computed: {
            ...mapGetters({
                getMember: 'getMember'
            }),

        },
    };
</script>



// WEBPACK FOOTER //
// src/components/Member/Sidebar.vue